import { isInterestingReferrer } from '../general/module/referredSiteVisit';

/**
 * RecentTeacherReferredDonor cookie
 * -- set when donor visits a teacher page
 * -- set when donor has a teacher rfParam
 * -- lasts 30 days
 * -- recentTRD
 */

function setRecentTeacherReferredDonorCookie(teacherId: number | string, source: string): void {
    window.createCookie('recentTRD', String(teacherId), 30);
    if (window.dcAnalytics) {
        window.dcAnalytics.track('recentTRD', { teacherId, source });
    }
}

export function setRecentTeacherReferredDonorCookieBasedOnRFParam(): void {
    if (window.getRfParamFromQueryStringOrHash(location.href)) {
        const teacherId = window.getRfParamTeacherId();
        if (teacherId && !window.isCurrentUser(teacherId)) {
            setRecentTeacherReferredDonorCookie(teacherId, 'rfParam');
        }
    }
}

/**
 *  Used in teacher_profile JS -- note that it only executes if
 *  -- there's no RF Param
 *  -- the referrer is not donorschoose.org
 */
export function setRecentTeacherReferredDonorCookieBasedOnTeacherPage(teacherIdInput: number | string): void {
    if (!teacherIdInput) {
        return;
    }
    const teacherId = parseInt(String(teacherIdInput));
    const isNotSelfReferred = !document.referrer || isInterestingReferrer(document.referrer);
    if (isNotSelfReferred && !window.getRfParamFromQueryStringOrHash(location.href) && !isNaN(teacherId) && !window.isCurrentUser(teacherId)) {
        setRecentTeacherReferredDonorCookie(teacherId, pageName);
    }
}

// used in optimizely audience
export function setAndReturnRecentTeacherReferredDonorCookieBasedOnTeacherPage(teacherId: number | string): boolean {
    if (pageName === 'teacher_profile') {
        setRecentTeacherReferredDonorCookieBasedOnTeacherPage(teacherId);
        return window.readCookie('recentTRD') !== null;
    }
    return false;
}
